"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackingData = exports.formatSessionData = exports.formatWatchListData = void 0;
const get_1 = __importDefault(require("lodash/get"));
const index_1 = require("@ebay-business-components/group-card/dist/interface/index");
const constants_1 = require("../../constants");
const formatWatchListData = (data, itemData, localizedContent) => {
    const accessibilityLabel = (0, get_1.default)(localizedContent, 'group_card_disabled_accessibility_label', '');
    const formatGroupCards = data.map((item) => {
        var _a;
        const { itemId, variationId } = itemData || {};
        const disabledValue = Boolean((_a = item === null || item === void 0 ? void 0 : item.items) === null || _a === void 0 ? void 0 : _a.some((filterItem) => (filterItem === null || filterItem === void 0 ? void 0 : filterItem.itemId) ===
            `${itemId}${variationId ? `-${variationId}` : ''}`));
        return {
            title: item.name,
            imageURLs: [item.imageUrl],
            trackingData: {
                eventFamily: 'MYEBAY',
                eventAction: 'CLICK',
                actionKind: 'ACTN',
                eventProperty: {
                    itm: item.id,
                    sid: item.id === 'WATCH_LIST'
                        ? constants_1.WATCH_LIST_SID
                        : constants_1.OTHER_LIST_SID,
                    id: item.id,
                },
            },
            id: item.id,
            theme: index_1.Themes.DEFAULT,
            imageTheme: disabledValue ? index_1.ImageThemes.ICON : index_1.ImageThemes.ROUNDED,
            disabled: {
                value: disabledValue,
                accessibilityLabel,
            },
        };
    });
    return formatGroupCards;
};
exports.formatWatchListData = formatWatchListData;
const formatSessionData = (watchData, addToWatchListSuccessResponse, listName) => {
    const { userWatchLists = [], status } = watchData;
    const { itemInfo, listId } = addToWatchListSuccessResponse;
    const watchListDataFormatted = [...userWatchLists];
    const existingList = watchListDataFormatted.find((item) => item.id === listId);
    if (existingList) {
        if (itemInfo && itemInfo.length > 0) {
            existingList.items = [
                ...existingList.items,
                ...itemInfo,
            ];
        }
    }
    else {
        const newItem = {
            id: listId || '',
            name: listName,
            imageUrl: '',
            items: itemInfo ? itemInfo : [],
        };
        watchListDataFormatted.splice(1, 0, newItem);
    }
    return {
        status,
        message: '',
        userWatchLists: watchListDataFormatted,
    };
};
exports.formatSessionData = formatSessionData;
const createTrackingData = (itemDetails, sid, listId) => {
    var _a, _b, _c;
    return ({
        eventAction: 'ACTN',
        eventFamily: 'MYEBAY',
        actionKind: 'CLICK',
        eventProperty: {
            id: listId,
            sid,
            itm: (_a = itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.itemData) === null || _a === void 0 ? void 0 : _a.itemId,
            var: (_b = itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.itemData) === null || _b === void 0 ? void 0 : _b.variationId,
            isMsku: String((_c = itemDetails === null || itemDetails === void 0 ? void 0 : itemDetails.itemData) === null || _c === void 0 ? void 0 : _c.isMSKU),
        },
    });
};
exports.createTrackingData = createTrackingData;
